import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { getPwaConfig, getPwaMode } from "./config/pwa";
import "./styles.css";

const pwaConfig = getPwaConfig();
document.documentElement.dataset.pwa = getPwaMode();
document.title = pwaConfig.name;
const manifestLink = document.createElement("link");
manifestLink.rel = "manifest";
manifestLink.href = pwaConfig.manifest;
document.head.appendChild(manifestLink);
document.querySelector('meta[name="theme-color"]')?.setAttribute("content", getPwaMode() === "campo" ? "#17675f" : getPwaMode() === "cliente" ? "#22577a" : "#123047");

window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
  window.wellInstallPrompt = event;
  window.dispatchEvent(new Event("well:install-ready"));
});
window.addEventListener("appinstalled", () => {
  window.wellInstallPrompt = null;
  localStorage.setItem("well_app_installed", "1");
  window.dispatchEvent(new Event("well:app-installed"));
});

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("WellTech frontend render failure", error, info);
  }

  render() {
    if (this.state.error) {
      return <main className="session-loading" role="alert">Falha ao carregar esta tela. Atualize a página ou retorne ao painel.</main>;
    }
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppErrorBoundary>
  </React.StrictMode>
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => navigator.serviceWorker.register(pwaConfig.serviceWorker));
}
